module.exports = __webpack_public_path__ + "components/flag/static/square/me-c90441283f4e1c73d88f14785e99ef3a.svg";